import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/imports')({
  staticData: { title: 'Imports' },
})
